import { en } from '../../../utils/en';

const bahFAQs = [
  {
    question: 'Who is eligible for BAH?',
    answer: [
      "  A member assigned to permanent duty within the 50 United States, who is not furnished government housing, is eligible for BAH, based on the member's rank, dependency status, and permanent duty station zip code.",
    ],
  },
  {
    question: 'What housing costs are used to set BAH rates?',
    answer: [
      'BAH rates are calculated using current median market rents and average local expenditures on utilities (electricity, water, sewer, and heating fuel) in each local market area, and will fluctuate as those costs change.',
    ],
  },
  {
    question: 'What impact does a promotion have on BAH?',
    answer: [
      'If you are promoted, your BAH rate is the then-current published BAH for your new (higher) grade, with the following exception. If you get promoted, and are in a location where the current published BAH for your new grade is lower than the BAH amount you were receiving before, you continue to receive the higher BAH amount.',
    ],
  },
  {
    question: 'BAH for my grade doesn’t cover my mortgage payment.',
    answer: [
      "BAH is based on rental data. A homeowner's monthly mortgage payment is not used in the computation because the monthly cash outlay of a homeowner is not a good indicator of the economic costs of home ownership. The variables needed to compute this include such difficult to measure factors as the expected appreciation in the value of the residence, the amount of down payment, the opportunity costs of interest from down payments, settlement costs, and the tax savings due to the interest and tax payments deduction. Therefore, BAH reflects the current rental market conditions not the historical circumstances surrounding various mortgage loans.",
    ],
  },
  {
    question:
      "What impact will removal of renter's insurance have on BAH rates?",
    answer: [
      "On average, the cost of renter's insurance contributed about $20/month to the Basic Allowance for Housing rates, with the actual amount varying by grade and location. Members who obtain renter's insurance will now need to budget for this expense separately.",
    ],
  },
  {
    question: 'Does family size make a difference?',
    answer: [
      'No. Although BAH distinguishes between with-dependent and without-dependent, the with-dependent compensation is based on comparable civilians using average family size.',
    ],
  },
  {
    question: 'How are BAH rates determined?',
    answer: [
      "BAH rates are based on local area rental market data and vary by geographic duty station, pay grade, and dependency status. The cost of utilities is also considered. BAH is based only on rental properties, not homeownership costs like mortgage payments and property taxes. BAH also includes rate protection. This means, if a member’s current BAH rate is less than the previous year, the member receives at least the same amount of BAH as the previous year, provided that the member’s duty location, rank and dependency status stays the same. If BAH rates go up, the member will receive the higher BAH rate as long as eligibility is uninterrupted. This ensures that members who have made long-term commitments in the form of a lease or contract are not penalized if the area's housing costs decrease.",
    ],
  },
  {
    question: 'Does BAH cover all housing costs?',
    answer: [
      'BAH enables service members to live off-base comparably to their civilian counterparts. It is not designed to cover all housing costs for all members. Some members may have out-of-pocket expenses, because rates are based on the median cost of rent. A member’s actual expenses may be higher or lower based on a member’s actual choice of housing and where they live. Because members are free to make housing choices that best suit their needs, a member may choose to use all their housing allowance to rent more expensive housing close to the duty station, or have a longer commute for either a larger or less expensive house in an outlying area.',
    ],
  },
];

const contactFAQs = [
  {
    question: 'Who is PCSgrades? ',
    answer: [
      'PCSgrades helps take the stress out of PCS! We are a community of fellow service members, veterans, and spouses helping each other with our biggest must-solve relocation needs through trusted insights and reviews about local neighborhoods, base housing, mortgage lenders, moving companies, schools, and more. Think of us as an Angie’s List or other trusted review platform like a Yelp, except we’re exclusive to the military and veteran community and focused on relocation and real estate needs. To learn more about us,',
    ],
    link: '/about-us',
  },
  {
    question: 'Why was PCSgrades founded? ',
    answer: [
      'PCSgrades was founded to address our biggest must solve relocation needs and is based on the strongly-held belief that the military family takes care of our own. Founder Todd Ernst took a hard look at the various challenges facing military families and found one recurring stressor: PCSing. Todd knew the easiest way for military families to navigate the murky waters of moving was by relying on the wisdom of those who have done it before.',
      'With PCSgrades, our fellow military members, veterans, and families are able to share community insights and reviews for our biggest, must-solve relocation needs, from the people we trust the most... each other.',
    ],
  },
  {
    question: 'Is PCSgrades a nonprofit?',
    answer: [
      'We get asked this a lot! PCSgrades is a socially responsible for-profit company staffed by veterans, military spouses, and military family members. Our heart is in serving our community. We are an approved resource by the Department of Defense’s Military OneSource for relocation information and assistance. While we are a for-profit company, our resources are free to the military and veteran community. If you use one of our real estate agents in our network to purchase a home, we receive a portion of the commission as a referral fee. But we don’t keep the entire referral fee because we’re serious about giving back to the military and veteran community. We use part of this referral fee to give money back to our customers! We give an average of $1,750 cash back when they buy or sell a home.* ',
    ],
  },
  {
    question: 'How does the rebate program work?',
    answer: [
      `We work with a group of top real estate agents from the most trusted brands in real estate: Coldwell Banker, Century 21, ERA, Better Homes and Gardens, and Corcoran. When you use one of our affiliated agents to purchase or sell your home, we’re able to offer you a cash back bonus of ${en.rebate_min_max}. The actual amount received is based on the price of the home and some exclusions apply based on location.*`,
    ],
  },
  {
    question:
      'What happens when I sign up for the Military Real Estate Rewards Program by PCSgrades?',
    answer: [
      `When you sign up for the PCSgrades Military Real Estate Rewards Program, you’re connected with a customer service representative who will take the time to better understand your real estate needs, asking questions like your timeframe for moving, wants and needs in a location, and your budget. Based on your needs, your customer service representative will connect you with a qualified, trusted real estate agent. Depending on where you’re located, if you buy or sell your home with the provided agent, you may be eligible for a cash back reward of ${en.rebate_min_max} based on the price of the home.* After you enroll in the program, you are under no obligation to remain with your agent or the program.`,
    ],
  },
  {
    question:
      'What if I’m buying a home in a state that’s different from where I’m living, am I still eligible for PCSgrades Military Real Estate Rewards Program?',
    answer: [
      'Great question! All rules and regulations apply to the state where the home is bought or sold.',
    ],
  },
  {
    question: 'Is it free to register for the program?',
    answer: [
      'Yes, it’s free to register for the program! PCSgrades is committed to providing free resources to the military and veteran community. Even better, if you do decide to buy or sell a home through our program, you may be eligible for a cash back reward. It’s our way of giving back and taking care of our own.',
    ],
  },
  {
    question: 'Am I obligated to use the program?  What if I change my mind?',
    answer: [
      'After you enroll in the PCSgrades Military Real Estate Rewards Program, you are under no obligation to remain with your agent or the program should you change your mind. But know that we’re here to help you, so tell us what we can do to make things better.',
      'Changed your mind about buying or selling a home? We still have trusted insights and reviews to help you with your upcoming move.',
    ],
  },
  {
    question: 'Are there hidden costs to this program after I sign up?',
    answer: [
      'No, there are no hidden costs! We hate sketchy website promos too! When you buy or sell a home through our program, the real estate company splits their commission with us. This commission split is a common practice in the real estate industry and is used to increase business for the real estate agent. But we don’t keep the entire referral fee because we’re serious about giving back to the military and veteran community. This is how we fund the cash back reward.',
    ],
  },
  {
    question:
      'Are there any states that do NOT allow rebates for the purchase or sale of my home?',
    answer: [
      'The cash back bonus is offered in most states. In some states, a gift card or commission reduction at closing may be provided in lieu of the cash back bonus. The program is not available for employer-sponsored relocations or transactions in Iowa or outside the United States. The cash back bonus is not available in Alaska and Oklahoma. In Kansas and Tennessee, a MasterCard MAX gift card will be issued. In Mississippi, New Jersey, and Oregon, a commission reduction may be available at closing.',
    ],
  },
  {
    question: 'How long will it take for an agent to contact me?',
    answer: [
      'Not long at all! Typically less than one business day. After discussing your real estate needs with your personal advocate, a real estate agent will contact you by phone.',
    ],
  },
  {
    question:
      'What if I’m not ready to buy or sell my home but I want more information?',
    answer: [
      'We completely understand. If you’re not ready to buy or sell your home but want more information, your PCSgrades customer service representative can set up a personalized home buying or selling timeline that makes the most sense for you. In the meantime, check out our resources.',
    ],
  },
  {
    question:
      'What if I want to remain anonymous when I create a review on PCSgrades? ',
    answer: [
      'That’s completely up to you! We only ask members to register with PCSgrades so we can validate military affiliation. However, members create their own username which is displayed with reviews, so you can protect your privacy and maintain public anonymity if preferred.',
    ],
  },
];

const condensedContactFAQs = [
  {
    question: 'How does the rebate program work?',
    answer: [
      `We work with a group of top real estate agents from the most trusted brands in real estate: Coldwell Banker, Century 21, ERA, Better Homes and Gardens, and Corcoran. When you use one of our affiliated agents to purchase or sell your home, we’re able to offer you a cash back bonus of ${en.rebate_min_max}. The actual amount received is based on the price of the home and some exclusions apply based on location.*`,
    ],
  },
  {
    question:
      'What happens when I sign up for the Military Real Estate Rewards Program by PCSgrades?',
    answer: [
      `When you sign up for the PCSgrades Military Real Estate Rewards Program, you’re connected with a customer service representative who will take the time to better understand your real estate needs, asking questions like your timeframe for moving, wants and needs in a location, and your budget. Based on your needs, your customer service representative will connect you with a qualified, trusted real estate agent. Depending on where you’re located, if you buy or sell your home with the provided agent, you may be eligible for a cash back reward of ${en.rebate_min_max} based on the price of the home.* After you enroll in the program, you are under no obligation to remain with your agent or the program.`,
    ],
  },
  {
    question: 'Is it free to register for the program?',
    answer: [
      'Yes, it’s free to register for the program! PCSgrades is committed to providing free resources to the military and veteran community. Even better, if you do decide to buy or sell a home through our program, you may be eligible for a cash back reward. It’s our way of giving back and taking care of our own.',
    ],
  },
  {
    question: 'Am I obligated to use the program?  What if I change my mind?',
    answer: [
      'After you enroll in the PCSgrades Military Real Estate Rewards Program, you are under no obligation to remain with your agent or the program should you change your mind. But know that we’re here to help you, so tell us what we can do to make things better.',
      'Changed your mind about buying or selling a home? We still have trusted insights and reviews to help you with your upcoming move.',
    ],
  },
  {
    question: 'Are there hidden costs to this program after I sign up?',
    answer: [
      'No, there are no hidden costs! We hate sketchy website promos too! When you buy or sell a home through our program, the real estate company splits their commission with us. This commission split is a common practice in the real estate industry and is used to increase business for the real estate agent. But we don’t keep the entire referral fee because we’re serious about giving back to the military and veteran community. This is how we fund the cash back reward.',
    ],
  },
  {
    question: 'I still have more questions. Where can I go to learn more? ',
    answer: [
      'To learn more about PCSgrades and our Real Estate Rewards Program',
    ],
    link: '/faqs',
  },
];

export { bahFAQs, contactFAQs, condensedContactFAQs };
